<template>
  <page :title="$tc('search._name')">
    <div class="box searches-tab">
      <b-tabs>
        <b-tab-item :label="$tc('search.last')" class="is-paddingless">
          <b-table
            class="is-middle"
            :loading="searches.loading"
            :data="searches.data"
            :current-page="searches.current_page"
            :per-page="searches.per_page"
            :total="searches.total"
            paginated
            backend-pagination
            pagination-position="bottom"
            @page-change="page => searches.changePage(page)"
          >
            <template slot-scope="props">
              <b-table-column :label="$tc('search.mostKeyword')">
                <div>{{ props.row.query }}</div>
              </b-table-column>

              <b-table-column :label="$tc('search.result')" centered>
                <span class="tag is-warning">{{ props.row.results_count }}</span>
              </b-table-column>

              <b-table-column :label="$tc('dater.date')" centered>{{ props.row.created_at }}</b-table-column>
            </template>
          </b-table>
        </b-tab-item>

        <b-tab-item :label="$tc('search.mostKeyword')">
          <b-table
            class="is-middle"
            :loading="topQueries.loading"
            :data="topQueries.data"
            :current-page="topQueries.current_page"
            :per-page="topQueries.per_page"
            :total="topQueries.total"
            paginated
            backend-pagination
            pagination-position="bottom"
            @page-change="page => topQueries.changePage(page)"
          >
            <template slot-scope="props">
              <b-table-column :label="$tc('search.useKeyword')" field="query">{{ props.row.query }}</b-table-column>

              <b-table-column :label="$tc('search.usedCount')" centered>
                <span class="tag is-warning">{{ props.row.count }}</span>
              </b-table-column>

              <b-table-column :label="$tc('search.result')" centered>{{ props.row.total_results_count }}</b-table-column>
            </template>
          </b-table>
        </b-tab-item>
      </b-tabs>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      topQueries: new window.PaginatedRemoteCollection(
        "/admin/api/searching-top-queries"
      ).load(),
      searches: new window.PaginatedRemoteCollection(
        "/admin/api/searches"
      ).load()
    };
  }
};
</script>

<style type="text/css">
.searches-tab .tab-content {
  padding: 0;
}
</style>
